<template>
    <div class="conversion-chart">
        <div ref="chart" class="chart"></div>
    </div>
</template>

<script>
  import moment from 'moment'
  import HighCharts from 'highcharts'

  import trafficSourcesMixin from '@/app/traffic-sources/traffic-sources.mixin'
  import datepickerMixin from '@/app/datepicker/datepicker.mixin'

  export default {
    mixins: [trafficSourcesMixin, datepickerMixin],
    props: {
      visible: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },

      conversions: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        chart: null,
        labels: [],
        series: [],
        lineWidth: 1,
        marker: {
          symbol: 'circle',
          radius: 3,
          lineWidth: 0,
          lineColor: '#fff'
        },
        cancel: null
      }
    },
    watch: {
      conversions: 'load'
    },

    mounted () {
      const visible = this.visible
      this.internalVisible = visible.length > 0 ? visible : this.sources.map(source => source.slug)
      this.load()
    },

    methods: {
      flattenConversionGroup (conversionGroup) {
        const clonedObject = JSON.parse(JSON.stringify(conversionGroup))

        let conversions = []

        clonedObject.conversions.forEach(conversion => {
          if (conversion.type === 'conversionGroup') {
            const subConversions = this.flattenConversionGroup(conversion)

            subConversions.forEach(subConversion => {
              conversions.push(subConversion)
            })
            return
          }

          conversions.push(conversion)
        })

        return conversions
      },

      load () {
        this.series = []
        this.labels = []
        const series = []

        const from = moment(this.from)
          .seconds(0)
          .minutes(0)
          .hours(0)

        const to = moment(this.to)
          .seconds(0)
          .minutes(0)
          .hours(0)

        for (let start = moment(from); start.isBefore(to); start.add(1, this.interval)) {
          start.seconds(0).minutes(0).hours(0)
          this.labels.push(this.getLabel(start))
        }

        const clonedConversions = JSON.parse(JSON.stringify(this.conversions))

        Object.keys(clonedConversions).forEach(conversionSource => {
          const conversions = this.flattenConversionGroup(clonedConversions[conversionSource])
            .filter(conversion => conversion.value > 0)
            .map(conversion => {
              conversion.moment = moment(conversion.date.date)
              conversion.moment.seconds(0).minutes(0).hours(0)

              return conversion
            })

          const groupedConversions = []

          for (let start = moment(from); start.isBefore(to); start.add(1, this.interval)) {
            const end = moment(start)
            end.add(1, this.interval)

            groupedConversions.push(conversions.filter(conversion => {
              const date = conversion.moment
              return date.isSameOrAfter(start) && date.isBefore(end)
            }).reduce((accumulator, conversion) => {
              return accumulator + conversion.value
            }, 0))
          }

          series.push({
            name: conversionSource,
            data: groupedConversions,
            marker: this.marker,
            color: this.conversions[conversionSource].serieColor,
            zoneAxis: 'x'
          })
        })

        this.series = series
        this.render()
      },

      render () {
        if (!this.$el) {
          return
        }

        const el = this.$el.querySelector('.chart')
        let series = this.series

        if (this.chart) {

          this.chart.series.forEach(serie => {
            const matchingSeries = this.series.filter(matchingSerie => matchingSerie.name === serie.name)

            if (!matchingSeries.length) {
              return
            }

            serie.update({
              data: matchingSeries[0].data
            })
          })

          this.chart.xAxis.categories = this.labels
        }

        const that = this

        this.chart = new HighCharts.Chart(el, {
          credits: false,
          chart: {
            type: 'area',
            stacking: 'normal',
            zoomType: 'x',
            height: 250
          },
          title: {
            text: null
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function () {
              let total = 0
              let string = '<strong>' + this.x + '</strong><br />'

              this.points.forEach(function (point) {
                string += that.translate(point.series.name, 'conversions') + ':'
                string += point.y
                string += '<br />'
                total += point.y
              })

              return string
            }
          },
          plotOptions: {
            area: {
              stacking: 'normal'
            },
            series: {
              marker: {
                enabled: true
              }
            }
          },
          xAxis: {
            categories: this.labels
          },
          yAxis: {
            title: {
              text: $t('conversions.conversions')
            }
          },
          series: series
        })
      }
    }
  }
</script>
